<template>
  <div class="discover-nav">
    <content-top-header class="black-theme">
      <template slot="topHeader" class="justify-content-start"> <!-- Changed from 'center' to 'start' -->
        <div class="dflex align-center">
          <ul class="pr-3">
            <li
              v-for="tab in tabs"
              :key="tab.id"
              :href="`#${tab.id}`"
              class="nav-li"
              :class="[{ active: isActiveTab(tab.id) }, `nav-${tab.id}`]"
            >
              <label class="nav-label" @click="onTab(tab.id)">
                {{ tab.title }} <!-- Removed the image and changed the text to 'Releases' -->
              </label>
            </li>
          </ul>
        </div>
      </template>
    </content-top-header>

    <v-dialog
      v-if="currentUser"
      v-model="show_genre_selector_dialog"
      :fullscreen="onMobile"
      :content-class="[`my-genre-dialog ma-0 pa-2 ${onMobile ? 'onMobile' : ''}`]"
    >
      <genre-dialog :dismiss="closeGenreSelectorDialog" />
    </v-dialog>
  </div>
</template>

<script>
import contentTopHeader from '@/components/contentTopHeader'
import SearchInput from '@/components/searchInput'
import genreDialog from '@/components/genre_dialog'

export default {
  props: {
    pageName: String,
    searchShow: Boolean,
    filterShow: String,
  },
  components: {
    contentTopHeader,
    SearchInput,
    genreDialog,
  },
  data() {
    return {
      keyword: "",
      activeTab: '',
      tabs: [
        { id: 'music', title: 'RELEASES' }, // Changed the title to 'RELEASES' and removed the icon
      ],
      show_genre_selector_dialog: false,
      got_genre_tooltip: false,
      hover_on_genre_button: false,
      hover_on_genre_tooltip: false,
    }
  },
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    currentUser() {
      return this.$store.state.auth.user
    },
    showGenreTooltip() {
      return (
        !this.got_genre_tooltip &&
        (this.hover_on_genre_button || this.hover_on_genre_tooltip)
      )
    },
  },
  methods: {
    closeGenreSelectorDialog() {
      this.show_genre_selector_dialog = false
      this.setTab(this.activeTab)
    },
    openGenreSelectorDialog() {
      this.show_genre_selector_dialog = true
    },
    isActiveTab(tab) {
      return this.activeTab === tab
    },
    onTab(tab) {
      this.activeTab = tab
      if (tab === 'music') {
        this.$router.push({ name: 'AlbumIndex' })
      }
    },
  },
  created() {
    if (this.pageName) {
      this.activeTab = this.pageName
    }
  },
}
</script>

<style lang="scss" scoped>
.discover-nav {
  .top-menu {
    /deep/.toolbar__content {
      justify-content: flex-start; /* Changed from 'center' to 'flex-start' */
    }
  }

  .toolbar__content ul li label.nav-label {
    color: white !important; /* White text */
    font-size: 18px; /* Adjust font size as needed */
    font-weight: bold; /* Make the text bold */
    margin-left: 0; /* Ensure the tab is floated left */
    background-color: black; /* Black background */
    padding: 10px 20px; /* Add padding to make it look like a button */
    border-radius: 5px; /* Rounded corners */
  }

  .toolbar__content ul li.active label.nav-label {
    color: white !important;
    background-color: black !important; /* Ensure active state also has black background */
  }
}

.w-100 {
  width: 100%;
}
.gap-10 {
  gap: 10px;
}
.genre-filter-icon {
  cursor: pointer;
}
.pos-relative {
  position: relative;
  .search-icon {
    position: absolute;
    left: 22px;
    top: 12px;
  }
}
.input-search {
  background-color: #272727 !important;
  height: 42px !important;
  border-radius: 50px !important;
  width: 350px !important;
  padding-left: 50px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  font-family: 'Inter', sans-serif;
  color: white !important;
  border: none !important;
}
.input-search::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.genre-dialog-selector {
  position: relative;
  width: 50px;
  display: flex;
  justify-content: flex-end;
  .genre-filter img {
    width: 20px;
    margin-top: 8px;
  }
  .tooltip {
    position: absolute;
    display: block;
    bottom: -63px;
    right: 48px;
    z-index: 9;
    width: 240px;
    padding: 0 0 10px 0;
    background-color: transparent;
    text-transform: initial;
    letter-spacing: -0.1px;
    .tooltip-arrow {
      position: absolute;
      top: -9px;
      right: -20px;
      width: 0;
      height: 0;
      margin: -2px;
      border-style: solid;
      border-color: #1e1e1e;
      border-width: 12px 12px 0;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      transform: rotate(180deg);
    }
    .tooltip-inner {
      position: relative;
      padding: 12px 12px 12px 12px;
      border-radius: 5px;
      background-color: #1e1e1e;
      color: #ffffff;
      text-align: left;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      width: 285px;
      margin-left: 12px;
      padding-left: 15px;
      a {
        position: absolute;
        top: 15px;
        right: 10px;
        padding: 5px 7px;
        border-radius: 5px;
        background-color: #4389f7;
        color: #ffffff;
      }
    }
  }
}

.back-btn {
  height: inherit !important;
  width: inherit !important;
  margin: 0;
}

.back-btn .btn__content::before {
  content: '\276E' !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// discoverNav.vue?599eadfd